import React from "react";
import Popup from '../../../components/popup';
import Checkbox from '../../../components/checkbox';
import Auth from '../../../lib/users/auth';
import AlertManager from '../../../managers/alert/alert-manager';

import CompaniesApi from '../../../lib/companies/companies-api';

import { ProceedButton, CancelButton } from '../../../components/buttons';

export default class AccountCompanyManageStaff extends  React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userRoles : []
        };
    }

    componentDidMount() {
        const {user } = this.props;
        this.setState({
            userRoles : user.roles
        });
    }

    confirm() {
        const {user, setPopup} = this.props;
        CompaniesApi.updateRoles(user.company_id, user.id, {role_ids : this.state.userRoles.map(role => role.id)}).then(() => {
            AlertManager.success(`${user.name} role updated`);
            setPopup();
        });
    }

    hasRole(role) {
        return _.findIndex(this.state.userRoles, r => {
            return r.id === role.id;
        }) !== -1;
    }

    updateRoles(role) {
        let updated = [role];
        this.setState({userRoles : updated});
    }

    render() {
        const {user, roles,  setPopup, contentId, onSuccess } = this.props;

        return (
            <Popup type="manage-staff">
                <div class="popup__inner">
                    <h1>Manage Staff Member: {user.name}</h1>

                    <div className="information">
                        <p className="information__label">Upgrade this users role and permissions</p>
                        <div className='utils__row utils__gap--20'>
                            {
                                roles.map((role, index) => {
                                    return(
                                        <Checkbox onChange={() => this.updateRoles(role)} key={index} text={role.name} checked={this.hasRole(role)} />
                                    )
                                })
                            }
                        </div>
                    </div>

                    <p className="manage-staff__warning">
                        If you wish to downgrade this user’s role, please remove this account and invite them again with the correct role assigned. Please ensure that the user has exported any important data related to this account or that another user can manage this data. If you require support or have a question, please contact us
                    </p>

                    <div class="popup__buttons">
                        <ProceedButton responsive={false} onClick={this.confirm.bind(this)}>Confirm</ProceedButton>
                        <CancelButton responsive={false} onClick={() => setPopup(false)}/>
                    </div>
                </div>
            </Popup>
        )
    }

}
